import React from 'react';
import '../../styles/onboarding.css';

/**
 * ChatBubble
 * A single chat message bubble, used inside OnboardingChatPanel.
 *
 * Props:
 *   role      — 'bot' | 'user'  (controls alignment and colour)
 *   children  — message content (string or JSX)
 */
const addMb0ToP = (html) =>
  html.replace(/<p\b([^>]*)>/g, (match, attrs) => {
    if (/class="([^"]*)"/.test(attrs)) {
      return match.replace(/class="([^"]*)"/, 'class="$1 mb-0"');
    }
    return `<p${attrs} class="mb-0">`;
  });

const ChatBubble = ({ role = 'bot', children }) => {
  const roleClass = role === 'user' ? 'hg-chat-bubble--user' : 'hg-chat-bubble--bot';

  if (typeof children === 'string') {
    return <div className={`hg-chat-bubble ${roleClass}`} dangerouslySetInnerHTML={{ __html: addMb0ToP(children) }} />;
  }

  return <div className={`hg-chat-bubble ${roleClass}`}>{children}</div>;
};

export default ChatBubble;
